import React from 'react'
import Header from './Header'
import HeroSection from './HeroSection'
import DemoSection from './DemoSection'
import ProblemSection from './ProblemSection'
//import SolutionSection from './SolutionSection'
import BenefitsSection from './BenefitsSection'
import ObjectionSection from './ObjectionSection'
import ErgonomicsSection from './ErgonomicsSection'
import ComparisonTable from './ComparisonTable'
//import PricingSection from './PricingSection'
import FAQSection from './FAQSection'
import Footer from './Footer'
import './Landing.css'

const LandingPage = () => {
  return (
    <div className="landing-page min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ProblemSection />
        {/*<SolutionSection />*/}
        <BenefitsSection />
        <DemoSection />
        <ObjectionSection />
        <ErgonomicsSection />
        <ComparisonTable />
        {/*<PricingSection />*/}
        <FAQSection />
      </main>
      <Footer />
    </div>
  )
}

export default LandingPage 